// ReportPeriodPicker — пикер периода отчёта (V14 W9, ТЗ §3.6): два MUI X DatePicker
// (from/to), локаль ru (LocalizationProvider уже в корне — AppProviders.tsx:37).
// Значение — Date|null для пикера; в ISO-границы дня (startOfDay/endOfDay) конвертирует
// страница (канон useCalendarView.hooks:62-63). Для as-of отчётов (funnel/risks) пикер
// НЕ рендерится самим ReportsPage (usePeriod=false в каталоге).

import { DatePicker } from '@mui/x-date-pickers';
import { Stack } from '@mui/material';
import { t } from '@/i18n';

/** Значение периода (локальные даты пикера). */
export interface ReportPeriodValue {
  from: Date | null;
  to: Date | null;
}

interface ReportPeriodPickerProps {
  value: ReportPeriodValue;
  onChange: (value: ReportPeriodValue) => void;
}

/** Пикер периода отчёта: from/to (оба опциональны; то же поведение, что в календаре). */
export function ReportPeriodPicker({ value, onChange }: ReportPeriodPickerProps): JSX.Element {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} data-testid="report-period-picker">
      <DatePicker
        label={t('reports.period.from')}
        value={value.from}
        onChange={(from: Date | null) => onChange({ ...value, from })}
        format="dd.MM.yyyy"
        slotProps={{ textField: { size: 'small' } }}
      />
      <DatePicker
        label={t('reports.period.to')}
        value={value.to}
        onChange={(to: Date | null) => onChange({ ...value, to })}
        format="dd.MM.yyyy"
        slotProps={{ textField: { size: 'small' } }}
      />
    </Stack>
  );
}
